<template>
    <div v-if="loaded">
        <div v-cloak class="vacancies">
            <div class="vacanciesHeader">
                <div class="vacanciesHeading">
                    <h3>Current</h3>
                    <h3 class="boldHeading">Vacancies</h3>
                </div>

                <div class="vacanciesTabs">
                    <ul>
                        <li>
                            <a :class="(tab_region == 'all') ? 'active' : ''" @click="update('all', tab_placement)">All</a>
                        </li>
                        <li v-for="(region, key) in regions">
                            <a :class="(tab_region == key) ? 'active' : ''" @click="update(key, tab_placement)">{{region}}</a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a :class="(tab_placement == 'all') ? 'active' : ''" @click="update(tab_region, 'all')">All</a>
                        </li>
                        <li v-for="(placement, key) in placement_types">
                            <a :class="(tab_placement == key) ? 'active' : ''" @click="update(tab_region, key)">{{placement}}</a>
                        </li>
                    </ul>
                </div>

                <div class="vacanciesSelect">
                    <div class="selectWrap">
                        <select @change="update(tab_region, tab_placement)" v-model="tab_region">
                            <option value="all">All</option>
                            <option v-for="(region, key) in regions" :value="key">{{region}}</option>
                        </select>
                    </div>
                    <div class="selectWrap">
                        <select @change="update(tab_region, tab_placement)" v-model="tab_placement">
                            <option value="all">All</option>
                            <option v-for="(placement, key) in placement_types" :value="key">{{placement}}</option>
                        </select>
                    </div>
                </div>

            </div>
            <div class="vacanciesBody">
                <div v-if="!loading">
                    <div v-if="vacancies.length > 0" class="vacanciesOutput">
                        <a v-for="vacancy in vacancies" class="vacancy" :href="vacancy.fields.url[0]" target="_blank">
                            <h5>{{ vacancy.fields.job_title[0] }}</h5>
                            <p>{{ vacancy.fields.location[0] }}</p>
                            <i class="far fa-arrow-right"></i>
                        </a>
                    </div>
                    <div v-else class="noVacancies">
                        No vacancies found
                    </div>
                </div>
                <div v-else class="loader">
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
            loading: true,
            tab_region: "all",
            tab_placement: "all",
            regions: [],
            placement_types: [],
            vacancies: [],
        };
    },
    mounted() {
        this.update(this.tab_region, this.tab_placement);
    },
    methods: {
        update(region, placement){
            var vue_instance = this;
            this.loading = true;
            this.tab_region = region;
            this.tab_placement = placement;

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    'action':'load_vacancies',
                    'tab_region' : region,
                    'tab_placement' : placement
                },
                success:function(data) {
                    var response = jQuery.parseJSON(data);
                    vue_instance.regions = response.regions;
                    vue_instance.placement_types = response.placement_types;
                    vue_instance.vacancies = response.vacancies;
                    vue_instance.loaded = true;
                    vue_instance.loading = false;
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }
}
</script>
